const Airbag = (props) => (
  <svg width='20.593' height='17.632' viewBox='0 0 20.593 17.632' fill='#fff' {...props}>
    <g transform='translate(0 0)'>
      <path
        d='M2629.3,342.61a3.989,3.989,0,0,1-4.081,4.068,4.053,4.053,0,0,1-4.1-4.21,4.143,4.143,0,0,1,4.126-4.008A4.083,4.083,0,0,1,2629.3,342.61Z'
        transform='translate(-2618.655 -338.459)'
      />
      <path
        d='M2593.462,522.753c-.721-.064-1.443-.12-2.163-.193-.693-.071-1.384-.169-2.077-.237a2.76,2.76,0,0,0-2.034.64c-.362.285-.725.569-1.09.849a2.949,2.949,0,0,1-4.25-.391.606.606,0,0,1,.126-1.037q2.325-1.534,4.667-3.044a3.932,3.932,0,0,1,2.255-.4,2.39,2.39,0,0,1,1.871.9c.877.958,1.831,1.846,2.753,2.763Z'
        transform='translate(-2581.61 -507.676)'
      />
      <path
        d='M2762.147,425.56c-1.211-1.21-2.371-2.361-3.517-3.525a.46.46,0,0,1-.061-.371c.256-1.011.5-2.026.8-3.024a2.259,2.259,0,0,1,4.34,1.216c-.389,1.6-.8,3.19-1.21,4.782A8.875,8.875,0,0,1,2762.147,425.56Z'
        transform='translate(-2747.518 -412.237)'
      />
      <path
        d='M2787.889,340.493a2.013,2.013,0,0,1,2.009-2.035,2.076,2.076,0,0,1,2.042,2.028,2.049,2.049,0,0,1-2.035,2.024A1.989,1.989,0,0,1,2787.889,340.493Z'
        transform='translate(-2775.021 -338.458)'
      />
      <path
        d='M2732.619,502.32l6.83,6.835-.631.576-6.81-6.8Z'
        transform='translate(-2722.626 -492.098)'
      />
      <path
        d='M2848.264,369.348l.626.762-3.539,2.966-.642-.752Z'
        transform='translate(-2828.298 -367.421)'
      />
    </g>
  </svg>
)

export default Airbag
